export default __webpack_public_path__ + "static/img-credit-score-old-vs-new-8dd5047d091ff8dac835bca022b04976.jpg";